import { getTemplates } from '../../services/data-entry/templates.service';

//Survey Templates
export const UPDATE_SURVEY_TEMPLATE_LIST = 'UPDATE_SURVEY_TEMPLATE_LIST';
export const TOGGLE_SURVEY_TEMPLATE_LIST_LOADING = 'TOGGLE_SURVEY_TEMPLATE_LIST_LOADING';
export const TEMPLATE_SURVEY_LIST_ERROR = 'TEMPLATE_SURVEY_LIST_ERROR';
export const TEMPLATE_SURVEY_UPDATE_TOTAL_LIST = 'TEMPLATE_SURVEY_UPDATE_TOTAL_LIST';
export const TEMPLATE_SURVEY_EXPORT_CHECKED_IDS = 'TEMPLATE_SURVEY_EXPORT_CHECKED_IDS';

export const updateSurveyTemplateList = (value = []) => ({
  type: UPDATE_SURVEY_TEMPLATE_LIST,
  payload: { name: 'list', value }
});

export const surveyTemplateListError = (value = null) => ({
  type: TEMPLATE_SURVEY_LIST_ERROR,
  payload: { name: 'error', value }
});

export const toggleLoadingSurveyTemplates = (value = false) => ({
  type: TOGGLE_SURVEY_TEMPLATE_LIST_LOADING,
  payload: { name: 'loading', value }
});

export const updateSurveyTemplatesTotalList = (value = 0) => ({
  type: TEMPLATE_SURVEY_UPDATE_TOTAL_LIST,
  payload: { value }
});

export const checkedTemplateIds = (ids = []) => ({
  type: TEMPLATE_SURVEY_EXPORT_CHECKED_IDS,
  ids
});

export const loadSurveyTemplateData = (skip = 0, limit = 50, filter, type = 'survey', active = true) => {
  return async (dispatch) => {
    try {
      dispatch(toggleLoadingSurveyTemplates(true));
      dispatch(surveyTemplateListError());

      const newFilter = { ...filter, roles: filter?.roles?.filter((item) => item !== 'all') };
      const { data } = await getTemplates(skip, limit, newFilter, type, active);

      if (data) {
        dispatch(updateSurveyTemplateList(data?.paginatedResults ?? []));
        dispatch(updateSurveyTemplatesTotalList(data?.totalRecords ?? 0));
        return;
      } else {
        dispatch(updateSurveyTemplateList([]));
        dispatch(updateSurveyTemplatesTotalList(0));
      }
    } catch (error) {
      dispatch(updateSurveyTemplateList([]));
      dispatch(updateSurveyTemplatesTotalList(0));
    } finally {
      dispatch(surveyTemplateListError());
      dispatch(toggleLoadingSurveyTemplates());
    }
  };
};
